module.exports = __webpack_public_path__ + "static/media/JH.80ee71d1.svg";